import { render, staticRenderFns } from "./InfluencerAudienceEdit.vue?vue&type=template&id=61fcb166"
import script from "./InfluencerAudienceEdit.vue?vue&type=script&lang=js"
export * from "./InfluencerAudienceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports